module.exports = __webpack_public_path__ + "img/preattentivegaze.6783a67e.png";